<template>
  <div id="product">
    <div class="item-area section-padding pb-bottom">
      <div class="container">
        <div class="row">

          <!-- left area -->
          <div class="col-12 col-lg-9 pr-left">
            <!-- 타이틀 -->
            <div class="section-tittle mt-2 mb-10">
              <h2>{{productDetail.pdtNameKor}}</h2>
              <p class="text-secondary" style="font-size:small; padding-left: 10px;">{{productDetail.pdtRemarks}}</p>
              <hr style="opacity:1; border-top:2px solid">
            </div>

            <!-- 사진 -->
            <div v-if="productImage.length > 0">
              <div id="carouselDetail" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
                <div class="carousel-indicators">
                  <button type="button"
                          v-for="(slide, index) in productImage.length"
                          :key="index"
                          :data-bs-target="'#carouselDetail'"
                          :data-bs-slide-to="index"
                          :class="{ active: index === 0 }"
                          :aria-current="index === 0 ? 'true' : null"
                          :aria-label="'Slide ' + (index + 1)">
                  </button>
                </div>
                <div class="carousel-inner">
                  <div :class="`carousel-item ${i==0 ? 'active' : ''}`" :key="i" v-for="(dImg, i) in productImage">
                    <img :src="`/download/${productId}/${dImg.imgName}`" class="d-block w-100" alt="...">
                  </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselDetail" data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselDetail" data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
                </button>
              </div>
            </div>
            <!-- <div v-else>
              <img :src="`/download/noImage/noImage.jpg`" class="card-img-top"/>
            </div> -->

            <!-- 상품번호 -->
            <div class="text-end">
              <span class="subheading">상품번호 : {{productDetail.pdtCode}}</span>
            </div>

            <!-- 교통편,체크포인트 -->
            <div class="vech">
              <table class="table">
                <tbody>
                  <tr>
                    <td class="stand">출&nbsp;&nbsp;&nbsp;&nbsp;발</td>
                    <td class="sub" v-if="productDetail.salesRoute === 'E'"> - </td>
                    <td class="sub" v-else>
                      <div v-if="productDetail.transFlag != '0'">
                        <b>교통편 </b> <span style="color:dimgray ">불포함</span>
                      </div>
                      <div v-else>
                        <b v-if="this.productDetail.salesRoute === 'L'"><span class="depart-de"></span>
                          <span style="color:black">
                            {{pdtTransInfo1.dpTpCode}}
                            <!-- {{pdtTransInfo1.dmobileCodeName}} {{pdtTransInfo1.dpTpCode}} -->
                          </span>
                        </b>
                        <b v-else style="color:black; font-size:1rem">
                          <!-- [출  국]&nbsp;&nbsp; -->
                          <span style="color:black" v-if="pdtTransInfo1.dmobileCodeName == undefined"> </span>
                          <span style="color:black" v-else>
                            {{pdtTransInfo1.dmobileCodeName}} ({{pdtTransInfo1.dmobileCode}}{{pdtTransInfo1.dpTpCode}})
                          </span>
                        </b>
                        <span class="brdown" v-if="this.productDetail.salesRoute === 'T' || this.productDetail.salesRoute === 'F'">
                          <span style="color:black" v-if="pdtTransInfo1.ddCodeName == undefined"> </span>
                          <span style="color:black" v-else>
                            {{pdtTransInfo1.ddCodeName}}({{pdtTransInfo1.d_dpTime}})
                            <i class="bi bi-caret-right-fill"></i>
                            {{pdtTransInfo1.daCodeName}}({{pdtTransInfo1.d_arTime}})
                          </span>
                        </span>
                      </div>

                      <div v-if="productDetail.transRemarks_dp == undefined"> </div>
                      <div v-else>
                        <small v-html="getStringFormat(this.productDetail.transRemarks_dp)"></small>
                      </div>

                    </td>
                  </tr>
                  <tr>
                    <td class="stand">도&nbsp;&nbsp;&nbsp;&nbsp;착</td>
                    <td class="sub" v-if="productDetail.salesRoute === 'E'"> - </td>
                    <td class="sub" v-else>
                      <div v-if="productDetail.transFlag != '0'">
                        <b>교통편 </b>  <span style="color:black ">불포함</span>
                      </div>
                      <div v-else>
                        <b v-if="this.productDetail.salesRoute==='L'">
                          <span style="color:black">
                            {{pdtTransInfo1.rtTpcode}}
                            <!-- {{pdtTransInfo1.rmobileCodeName}} {{pdtTransInfo1.rtTpcode}} -->
                          </span>
                        </b>
                        <b v-else style="color:black; font-size:1rem">
                          <!-- [귀  국]&nbsp;&nbsp; -->
                          <span style="color:black" v-if="pdtTransInfo1.rmobileCodeName == undefined"> </span>
                          <span style="color:black" v-else>
                            {{pdtTransInfo1.rmobileCodeName}} ({{pdtTransInfo1.rmobileCode}}{{pdtTransInfo1.rtTpcode}})
                          </span>
                        </b>
                        <span class="brdown" v-if="this.productDetail.salesRoute === 'T' || this.productDetail.salesRoute === 'F'">
                          <span style="color:black" v-if="pdtTransInfo1.rdCodeName == undefined"> </span>
                          <span style="color:black" v-else>
                            {{pdtTransInfo1.rdCodeName}}({{pdtTransInfo1.r_dpTime}})
                            <i class="bi bi-caret-right-fill"></i>
                            {{pdtTransInfo1.raCodeName}}({{pdtTransInfo1.r_arTime}})
                          </span>
                        </span>
                      </div>
                      <div v-if="productDetail.transRemarks_ar == undefined"> </div>
                      <div v-else>
                        <small v-html="getStringFormat(this.productDetail.transRemarks_ar)"></small>
                      </div>
                    
                    </td>
                  </tr>
                  <tr>
                    <td class="stand text-danger">체크사항</td>
                    <td class="sub">
                      <div class="text-start">
                        <small class="checkPoint">{{this.productDetail.supLookup}}</small>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="pdtOptFlag === 'Y'">
                    <td class="stand text-primary">
                      선택옵션
                      <!-- <p style="font-size:small; font-weight:normal; color:black;">(금일기준)</p> -->
                    </td>
                    <td class="sub">
                      <div class="text-start">
                        <p class="mt-0 mb-1" :key="i" v-for="(op, i) in pdtOptInfo_start">
                          <small class="checkPoint"><b><i class="bi bi-check2 text-primary"></i> {{ op.optPdtName }}</b>
                            <p style="padding-left:2rem;">{{ op.optPdtRemarks }}</p>
                          </small>
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="addPdtFlag === 'Y'">
                    <td class="stand text-success">
                      추가상품
                      <!-- <p style="font-size:small; font-weight:normal; color:black;">(금일기준)</p> -->
                    </td>
                    <td class="sub">
                      <div class="text-start">
                        <p class="mt-0 mb-1" :key="j" v-for="(ap, j) in addPdtInfo_start">
                          <small class="checkPoint"><b><i class="bi bi-check2 text-success"></i> {{ ap.addPdtName }}</b>
                            <p style="padding-left:2rem;">{{ ap.addPdtRemarks }}</p>
                          </small>
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 포함,불포함 -->
            <div class="in-non">
              <table class="table">
                <thead>
                  <tr>
                    <th style="color: #0004d6"><i class="fa-regular fa-circle fa-xs"></i> &nbsp;포함사항</th>
                    <th style="color: #e20400"><i class="fa-solid fa-x fa-xs"></i> &nbsp;불포함사항</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="col-6"><pre class="inclusion">{{ this.productDetail.inContent }}</pre></td>
                    <td class="col-6"><pre class="notInclusion">{{ this.productDetail.exContent }}</pre></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 카테고리 -->
            <div class="category">
              <div class="container">
                <div class="tab-content mt-4">
                  <!-- 구분 -->
                  <section class="clist">
                    <div class="p-1">
                      <ul class="nav nav-tabs justify-content-center">
                        <li class="nav-item">
                          <a data-bs-toggle="tab">
                            <a class="nav-link active show" href="#tab-1"><h4>상품설명</h4></a>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a data-bs-toggle="tab">
                            <a class="nav-link" href="#tab-2"><h4>안내사항</h4></a>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a data-bs-toggle="tab">
                            <a class="nav-link" href="#tab-3"><h4>취소안내</h4></a>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a data-bs-toggle="tab">
                            <a class="nav-link" href="#tab-4"><h4>이용후기</h4></a>
                          </a>
                        </li>
                        <li class="nav-item" @click="inquiryProduct()">
                          <a data-bs-toggle="tab">
                            <a class="nav-link" href="#"><h4>상품문의</h4></a>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </section>

                  <!-- 상품상세이미지 -->
                  <div class="tab-pane mb-5 active show" id="tab-1">
                    <div class="row">
                      <div class="row" v-if="this.productDetailImage.length > 0">
                        <div class="col-12" :key="i" v-for="(detailImg, i) in productDetailImage">
                          <img :src="`/download/${productId}/${detailImg.imgName}`" class="img-fluid" style="width:100%;"/>
                        </div>
                      </div>
                      <div class="row" v-else>
                        <div class="col-12">
                          <img :src="`/download/noImage/noImage.jpg`" class="img-fluid" style="width:100%;"/>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 안내사항 -->
                  <div class="tab-pane my-5" id="tab-2">
                    <div class="row">
                      <div class="col-lg-12 order-2 order-lg-1 mt-3 mt-lg-0 text-start">
                        <h4>안내사항</h4>
                        <hr style="color:#bbb;">
                        <pre class="supPre">{{ this.productDetail.supPrecaution }}</pre>
                      </div>
                    </div>
                  </div>

                  <!-- 취소안내 -->
                  <div class="tab-pane my-5" id="tab-3">
                    <div class="row">
                      <div class="col-lg-12 order-2 order-lg-1 mt-3 mt-lg-0 text-start">
                        <h4>취소수수료 안내</h4>
                        <hr style="color:#bbb;">
                        <!-- <p>{{ getStringFormat(this.productDetail.supCancellation) }}</p> -->
                        <pre class="supCxl">{{ this.productDetail.supCancellation }}</pre>
                      </div>
                    </div>
                  </div>

                  <!-- 이용후기 -->
                  <div class="tab-pane creview my-5" id="tab-4">
                    <div class="row d-flex justify-content-between align-items-start">
                      <div class="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 text-start">
                        <h4>이용후기</h4>
                        <!-- <p class="text-secondary mt-0">
                          상품이용 후, 30일 이내에 작성된 내용입니다.
                        </p> -->
                      </div>
                    </div>
                    <hr style="color:#bbb;">

                    <!-- 상품별 후기리스트 -->
                    <div class="container">
                      <div v-if="this.reviewList.length > 0">
                        <div class="row" :key=i v-for="(rl, i) in this.reviewList">
                          <div class="col-lg-3 mt-2">
                            <img v-if="!rl.imgName || rl.iUseFlag == 'N'" :src="`/download/noImage/noImage2.jpg`" class="img-fluid" style="width: 250px; height:200px; border: 1px dotted lightgrey;" title="리뷰어의 이미지가 없습니다" />
                            <img v-else :src="`/download/review/${rl.revCode}/${rl.imgName}`" class="img-fluid" style="width: 250px; height:200px" />
                          </div>
                          <div class="c-content col-lg-9 text-start align-self-center">
                            <div class="reviewt d-inline-block text-truncate" style="max-width: 330px;" v-if="rl.insId === this.user.email">
                              {{ rl.nTitle }}&nbsp;
                              <button type="button" class="btn btn-outline-secondary btn-sm me-1 align-top" @click="changeReview(rl.revCode, rl.seqNotice, rl.seqImg);">
                                <span style="font-size:small">변경</span>
                              </button>
                            </div>
                            <div class="reviewt d-inline-block text-truncate" style="max-width: 330px;" v-else>{{ rl.nTitle }}</div>
                            <div class="reviewn text-end">
                              <span class="name">{{ rl.rId.substring(0,3) }}○○○님</span>
                              <span class="date">{{ this.getDateFormat(rl.rDate) }}</span>
                            </div>
                            <div class="reviewc">
                              <pre class="reviewContent">{{ rl.nContent }}</pre>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div class="row">
                          <div class="col-lg-3 mt-2 text-center">
                            아직 등록된 후기가 없습니다.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 오른쪽 리모콘 -->
          <div class="col-md-3">
            <div class="pr-right">
              <!-- 달력 -->
              <div class="container">

                <!-- 달력형상품 -->
                <div class="calendar" v-if="this.dTypeFlag === 'Y'">
                  <div class="calendar-header">
                    <button class="calendarbtn" @click="previousMonth()">
                      <i class="bi bi-chevron-left"></i>
                    </button>
                    <div class="d-flex align-items-center">
                      <button class="calendarbtn mt-1" @click="goToCurrentMonth()">
                        <i class="bi bi-calendar3"></i>
                      </button>
                      <div class="calendar-header-date">
                        {{ this.currentDate ? this.currentDate.format('YYYY-MM') : '' }}
                      </div>
                    </div>
                    <button class="calendarbtn" @click="nextMonth()">
                      <i class="bi bi-chevron-right"></i>
                    </button>
                  </div>
                  <div class="calendar-body">
                    <div class="calendar-row">
                      <div class="calendar-day-header text-danger">일</div>
                      <div class="calendar-day-header">월</div>
                      <div class="calendar-day-header">화</div>
                      <div class="calendar-day-header">수</div>
                      <div class="calendar-day-header">목</div>
                      <div class="calendar-day-header">금</div>
                      <div class="calendar-day-header text-primary">토 </div>
                    </div>
                    <div v-for="(week, index) in weeks" :key="index" class="calendar-row">
                      <div v-for="(day, index) in week" :key="index" class="calendar-day" :class="{ today: isToday(day.date), selected: isSelected(day.date)}" @click="goTo('resBtn');selectDate_new(day.date)">
                        <div v-if="day.date && day.date.day() === 0" class="calendar-date text-danger">
                          {{ day.date.date() }}
                        </div>
                        <div v-else-if="day.date && day.date.day() === 6" class="calendar-date text-primary">
                          {{ day.date.date() }}
                        </div>
                        <div v-else-if="day.date && (day.date.day() !== 6 && day.date.day() !== 0)" class="calendar-date">
                          {{ day.date.date() }}
                        </div>
                        <div v-if="day.price" class="calendar-price">
                          {{ getCurrencyFormat(formatManCurrency(day.price)) }}<span style="font-size: smaller; color:darkgray;">만</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr style="margin:0px 20px 0; opacity:.5" v-if="this.inquiryFlag === 'Y'">

                  <div class="price" v-if="this.inquiryFlag === 'Y'">
                    <table>
                      <tr class="row col-12 text-center">
                        <td><i class="bi bi-check2-circle" style="font-size:small; color:brown;"></i> {{ this.selectedDate }} ({{ this.getDayOfWeek(this.selectedDate) }})</td>
                      </tr>
                      <!-- 직접형 옵션표시 -->
                      <tr class="row col-12" v-if="this.dirOptFlag === 'Y'">
                        <td>
                          <span style="font-weight:normal; color:darkgray;">[필수입력사항]</span>
                          <div :key="i" v-for="(od, i) in this.dirOptInfo" class="mt-1">
                            <input type="text" :placeholder="od.odName" v-model="od.odValue"/>
                          </div>
                        </td>
                      </tr>
                      <tr class="row col-12" v-if="this.selOptFlag == 'Y'">
                        <td>
                          <span style="font-weight:normal; color:darkgray;">[필수선택옵션]</span>
                          <div class="border rounded" style="width:295px;">
                            <select class="form-select form-select-sm" v-model="choicedSelOpt" @change="validateDirectOptions(choicedSelOpt)">
                              <option value="noVal" disabled>
                                옵션을 선택해주세요
                              </option>
                              <option :value="os.os3" :key="j" v-for="(os,j) in selectedCalPdtPrice ">
                                {{ os.os3 }} ({{ this.getCurrencyFormat(os.pdtPrice_org) }}원)
                              </option>
                            </select>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

                <!-- 비달력형 상품 -->
                <div class="calendar" v-else>
                  <div>
                    <p style="font-size: 1.1rem; font-weight: 600; margin-top: 5px;">
                      {{ this.productDetail.pdtNameKor }}<br>
                    </p>
                    <p style="text-align: end; padding-right: 10px;" v-for="(so, i) in selectedCalPdtPrice" :key="i">
                      {{ so.os1 }}:&nbsp;&nbsp; <span style="color:red; font-weight: 600;">{{ this.getCurrencyFormat(so.pdtPrice_org) }}원</span>
                    </p>                    
                  </div>
                
                  <hr style="margin:0px 20px 0; opacity:.5" v-if="this.inquiryFlag === 'Y'">

                  <!-- 비달력형가격 -->
                  <div class="price" v-if="this.inquiryFlag === 'Y'">
                    <table>
                      <!-- 직접형 옵션표시 -->
                      <tr class="row col-12" v-if="this.dirOptFlag === 'Y'">
                        <td>
                          <span style="font-weight:normal; color:darkgray;">[필수입력사항]</span>
                          <div :key="i" v-for="(od, i) in this.dirOptInfo" class="mt-1">
                            <input type="text" :placeholder="od.odName" v-model="od.odValue"/>
                          </div>
                        </td>
                      </tr>
                      <tr class="row col-12" v-if="this.selOptFlag == 'Y'">
                        <td>
                          <span style="font-weight:normal; color:darkgray;">[필수선택옵션]</span>
                          <div class="border rounded" style="width:295px;">
                            <select class="form-select form-select-sm" v-model="choicedSelOpt" @change="validateDirectOptions(choicedSelOpt)">
                              <option value="noVal" disabled>
                                옵션을 선택해주세요
                              </option>
                              <option :value="os.os1" :key="j" v-for="(os,j) in selectedCalPdtPrice ">
                                {{ os.os1 }} ({{ this.getCurrencyFormat(os.pdtPrice_org) }}원)
                              </option>
                            </select>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                </div>

                <hr class="mt-2 mb-2" style="margin:0px 20px 0; opacity:.5"  v-if="this.inquiryFlag === 'Y'">

              <div id="resBtn"></div>

              <!-- 가격계산영역 -->
              <div class="total-P mt-1 mb-3" v-if="this.inquiryFlag === 'Y'">
                <table>
                  <tr class="row" style="width: 100%;" v-for="(item, index) in rsvData_temp" :key="index">
                    <td style="width: 100%; height: 150px; font-size: 0.8rem; padding-left: 10px; width: 100%;">
                      <div style="width: 340px; color: darkgray; margin: 0; white-space: normal; overflow-wrap: break-word; word-break: break-all;">
                        {{ item.selOptName }} / {{ item.departureDate }}
                        <span v-for="(val, idx) in item.directOptions" :key="idx"> / {{ val }}</span>
                        <span style="padding-left: 5px;"><i class="bi bi-x-square text-danger" style="font-size: 0.9rem; font-weight: 600; cursor: pointer;" @click="deletePrice(item.selOptName)"></i></span>
                      </div>
                      <div style="display: flex; align-items: center; justify-content: space-between;">
                        <div class="btn-group" style="padding-left: 20px; padding-top: 30px;">
                          <button class="btn btn-outline-danger btn-sm left" @click="numCount('M', item.selOptName)">
                            <i class="bi bi-dash-lg text-danger fw-bolder"></i>
                          </button>
                          <span class="number" style="font-size: 1.2rem; font-weight: 600; width: 40px; text-align: center;">{{ item.count }}</span>
                          <button class="btn btn-outline-primary btn-sm right" @click="numCount('P', item.selOptName)">
                            <i class="bi bi-plus-lg text-primary fw-bolder"></i>
                          </button>
                        </div>
                        <div class="text-end" style="padding-top: 30px; padding-right: 15px;">
                          <b class="fs-4">{{ this.getCurrencyFormat(item.pdtPrice * item.count) }}</b> 원        
                        </div>
                      </div>

                    </td>
                  </tr>
                </table>

                <hr class="mb-0" style="margin:0px 10px 0; opacity:.5" v-if="this.rsvData_temp.length > 0">

                <!-- 선택상품총액 -->
                <table>
                  <tr v-if="this.selectedCalPdtPrice.length > 0">
                    <td style="width: 340px; height: 80px; text-align: right; padding-right: 20px;">
                      <div class="mt-0 text-danger" style="font-size: 1.8rem; font-weight: 800;">
                        <span style="font-size: 1.2rem; color: darkgray;">총 상품액&nbsp;&nbsp;&nbsp;</span>{{ this.getCurrencyFormat(sumPdtPrice) }}
                        <span style="font-size: 1.2rem; color: darkgray;">원</span>
                      </div>
                    </td>
                  </tr>
                </table>


                <!-- PC화면 예약하기 버튼 -->
                <table>
                  <tr v-if="this.selectedCalPdtPrice.length > 0">
                    <td class="text-center align-middle" colspan="2">
                      <div class="pr-go text-center" id="p_resBtn" style="width: 300px;">
                        <a href="javascript: void(0)" @click="orderCheck_new('p')">
                            <p>예약하기</p>
                        </a>
                      </div>
                    </td>
                  </tr>
                </table>

              </div>
            </div>
          </div>

          <!-- 모바일화면용 예약달력 -->
          <div class="container mobile-cal">
            <a class="openm js-click-modal" @click="toggleModal()">예약시작</a>

            <div class="modal2" v-if="this.showModal2" @click.self="closeModal2()">
              <div class="body">
                <div class="container">

                  <!-- 달력형 상품 -->
                  <div class="calendar" v-if="this.dTypeFlag === 'Y'">
                    <div class="calendar-header">
                      <button class="calendarbtn" @click="previousMonth()">
                        <i class="bi bi-chevron-left"></i>
                      </button>
                      <div class="d-flex align-items-center">
                        <button class="calendarbtn mt-1" @click="goToCurrentMonth()">
                          <i class="bi bi-calendar3"></i>
                        </button>
                        <div class="calendar-header-date">
                          {{ this.currentDate ? this.currentDate.format('YYYY-MM') : '' }}
                        </div>
                      </div>
                      <button class="calendarbtn" @click="nextMonth()">
                        <i class="bi bi-chevron-right"></i>
                      </button>
                    </div>
                    <div class="calendar-body">
                      <div class="calendar-row">
                        <div class="calendar-day-header text-danger">일</div>
                        <div class="calendar-day-header">월</div>
                        <div class="calendar-day-header">화</div>
                        <div class="calendar-day-header">수</div>
                        <div class="calendar-day-header">목</div>
                        <div class="calendar-day-header">금</div>
                        <div class="calendar-day-header text-primary">토 </div>
                      </div>
                      <div v-for="(week, index) in weeks" :key="index" class="calendar-row">
                        <div v-for="(day, index) in week" :key="index" class="calendar-day"
                            :class="{ today: isToday(day.date), selected: isSelected(day.date)}" @click="goTo('resBtn');selectDate_new(day.date)">
                          <div v-if="day.date && day.date.day() === 0" class="calendar-date text-danger">
                            {{ day.date.date() }}
                          </div>
                          <div v-else-if="day.date && day.date.day() === 6" class="calendar-date text-primary">
                            {{ day.date.date() }}
                          </div>
                          <div v-else-if="day.date && (day.date.day() !== 6 && day.date.day() !== 0)" class="calendar-date">
                            {{ day.date.date() }}
                          </div>
                          <div v-if="day.price" class="calendar-price">
                            {{ getCurrencyFormat(formatManCurrency(day.price)) }}<span style="font-size: smaller; color:darkgray;">만</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr style="margin:0px 20px 0; opacity:.5" v-if="this.inquiryFlag === 'Y'">

                    <!-- 가격 -->
                    <div class="price" v-if="this.inquiryFlag === 'Y'">
                      <table>
                        <tr class="row col-12 text-center">
                          <td><i class="bi bi-check2-circle" style="font-size:small; color:brown;"></i> {{ this.selectedDate }} ({{ this.getDayOfWeek(this.selectedDate) }})</td>
                        </tr>
                        <!-- 직접형 옵션표시 -->
                        <tr class="row col-12" v-if="this.dirOptFlag === 'Y'">
                          <td style="border: darkgray solid 1px; border-radius: 5px; background-color: aliceblue; padding: 10px; vertical-align: middle;">
                            <span style="font-weight:normal; color:darkgray; padding-left: 10px; font-size: 0.9rem;">[필수입력사항]</span>
                            <div v-for="(od, i) in dirOptInfo" :key="i" class="mt-1" style="width: 100%;">
                              <input type="text" class="form-control doInput" style="font-size: 1rem; display: block; margin-left: auto; margin-right: auto;" :placeholder="od.odName" v-model="od.odValue"/>
                            </div>
                          </td>
                        </tr>

                        <tr class="row col-12 mt-3" v-if="this.selOptFlag == 'Y'">
                          <td>
                            <span style="font-weight:normal; color:darkgray; font-size:0.9rem; padding-left: 12px;">[필수선택옵션]</span>
                            <div class="border rounded" style="width:100%;">
                              <select class="form-select form-select-sm" v-model="choicedSelOpt" @change="validateDirectOptions(choicedSelOpt)">
                                <option value="noVal" disabled>
                                  옵션을 선택해주세요
                                </option>
                                <option :value="os.os3" :key="j" v-for="(os,j) in selectedCalPdtPrice ">
                                  <span style="font-size: 0.9rem;">{{ os.os3 }} ({{ this.getCurrencyFormat(os.pdtPrice_org) }}원)</span>
                                </option>
                              </select>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  
                  <!-- 비달력형 상품 -->
                  <div class="calendar" v-else>
                    <div>
                      <p style="font-size: 1.1rem; font-weight: 600; margin-top: 5px;">
                        {{ this.productDetail.pdtNameKor }}<br>
                      </p>
                      <p style="text-align: end; padding-right: 10px;" v-for="(so, i) in selectedCalPdtPrice" :key="i">
                        {{ so.os1 }}:&nbsp;&nbsp; <span style="color:red; font-weight: 600;">{{ this.getCurrencyFormat(so.pdtPrice_org) }}원</span>
                      </p>
                    </div>

                    <!-- 가격 -->
                    <div class="price" v-if="this.inquiryFlag === 'Y'">
                      <table>
                        <!-- 직접형 옵션표시 -->
                        <tr class="row col-12" v-if="this.dirOptFlag === 'Y'">
                          <td style="border: darkgray solid 1px; border-radius: 5px; background-color: aliceblue; padding: 10px; vertical-align: middle;">
                            <span style="font-weight:normal; color:darkgray; padding-left: 10px; font-size: 0.9rem;">[필수입력사항]</span>
                            <div v-for="(od, i) in dirOptInfo" :key="i" class="mt-1" style="width: 100%;">
                              <input type="text" class="form-control doInput" style="font-size: 1rem; display: block; margin-left: auto; margin-right: auto;" :placeholder="od.odName" v-model="od.odValue"/>
                            </div>
                          </td>
                        </tr>

                        <tr class="row col-12 mt-3" v-if="this.selOptFlag == 'Y'">
                          <td>
                            <span style="font-weight:normal; color:darkgray; font-size:0.9rem; padding-left: 12px;">[필수선택옵션]</span>
                            <div class="border rounded" style="width:100%;">
                              <select class="form-select form-select-sm" v-model="choicedSelOpt" @change="validateDirectOptions(choicedSelOpt)">
                                <option value="noVal" disabled>
                                  옵션을 선택해주세요
                                </option>
                                <option :value="os.os1" :key="j" v-for="(os,j) in selectedCalPdtPrice ">
                                  <span style="font-size: 0.9rem;">{{ os.os1 }} ({{ this.getCurrencyFormat(os.pdtPrice_org) }}원)</span>
                                </option>
                              </select>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                </div>

                <hr class="mt-3 mb-2" style="margin:0px 20px 0; opacity:.5" v-if="this.inquiryFlag === 'Y'">

                <!-- 가격계산영역 -->
                <div class="total-P mt-1 mb-3" v-if="this.inquiryFlag === 'Y'">
                  <table>
                    <tr class="row" style="width: 100%;" v-for="(item, index) in rsvData_temp" :key="index">
                      <td style="width: 100%; height: 120px; font-size: 0.8rem; padding-left: 10px; width: 100%;">
                        <div style="width: 340px; color: darkgray; margin: 0; white-space: normal; overflow-wrap: break-word; word-break: break-all;">
                          {{ item.selOptName }} / {{ item.departureDate }}
                          <span v-for="(val, idx) in item.directOptions" :key="idx"> / {{ val }}</span>
                          <span style="padding-left: 5px;"><i class="bi bi-x-square text-danger" style="font-size: 0.9rem; font-weight: 600; cursor: pointer;" @click="deletePrice(item.selOptName)"></i></span>
                        </div>
                        <div style="display: flex; align-items: center; justify-content: space-between;">
                          <div class="btn-group" style="padding-left: 20px; padding-top: 20px;">
                            <button class="btn btn-outline-danger btn-sm left" @click="numCount('M', item.selOptName)">
                              <i class="bi bi-dash-lg text-danger fw-bolder"></i>
                            </button>
                            <span class="number" style="font-size: 1.1rem; font-weight: 600; width: 40px; text-align: center;">{{ item.count }}</span>
                            <button class="btn btn-outline-primary btn-sm right" @click="numCount('P', item.selOptName)">
                              <i class="bi bi-plus-lg text-primary fw-bolder"></i>
                            </button>
                          </div>
                          <div class="text-end" style="padding-top: 30px; padding-right: 15px;">
                            <b class="fs-4">{{ this.getCurrencyFormat(item.pdtPrice * item.count) }}</b> 원        
                          </div>
                        </div>

                      </td>
                    </tr>
                  </table>

                  <hr class="mb-0" style="margin:0px 10px 0; opacity:.5" v-if="this.rsvData_temp.length > 0">

                  <!-- 선택상품총액 -->
                  <table>
                    <tr v-if="this.selectedCalPdtPrice.length > 0">
                      <td style="width: 340px; height: 80px; text-align: right; padding-right: 20px;">
                        <div class="mt-0 text-danger" style="font-size: 1.5rem; font-weight: 800;">
                          <span style="font-size: 1.1rem; color: darkgray;">총 상품액&nbsp;&nbsp;&nbsp;</span>{{ this.getCurrencyFormat(sumPdtPrice) }}
                          <span style="font-size: 1.1rem; color: darkgray;">원</span>
                        </div>
                      </td>
                    </tr>
                  </table>

                  <div id="resBtn"></div>
                  <!-- 예약하기 버튼 -->
                  <table>
                    <tr v-if="this.selectedCalPdtPrice.length > 0">
                      <td class="text-center align-middle" colspan="2">
                        <div class="pr-go text-center" id="m_resBtn" style="width: 300px;">
                          <a href="javascript: void(0)" @click="orderCheck_new('p')">
                              <p>예약하기</p>
                          </a>
                        </div>
                      </td>
                    </tr>
                  </table>

                </div>

              <!-- 닫기버튼 -->
              <a class="closem js-close-modal">
                <i class="bi bi-x-square text-danger" style="cursor:pointer" @click.stop="closeModal2()"></i>
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

</template>

<script>
import moment from 'moment';
import {genCode} from '../assets/js/genCode'
//import { reactive } from 'vue';

export default {
  // components:
  // {
  //   DatePicker
  // },
  // DB에서 가져온 데이타
  data() {
    return {
      memberFlag: "",                         //회원여부

      pdt_minPrice: 0,                        //금일기준 향후 상품최소가격
      pdt_basicPrice: 0,                      //금일기준 향후 상품기본가격
      prcCode: '',                            //상품가격코드
      osCode: '',                             //활성화된 선택형 옵션코드
      dirOptFlag: 'N',                        //직접형 옵션유무
      selOptFlag: 'N',                        //선택형 옵션유무
      dTypeFlag: '',                          //날짜형 가격체계 여부

      calPdtPrice:  [],                       //일자별 상품가격
      priceData: [],                          //달력표시용 일자별 최저가
      dirOptInfo: [],                         //직접형 옵션정보
      choicedSelOpt: '',                      //선택된 옵션명(권종명)

      selectedCalPdtPrice: [],                //선택된 날짜의 상품가격

      inquiryFlag: "N",                       //예약영역 표시플래그

      rsvData_temp: [],                       //예약정보 임시저장용(선택옵션명, 출발일시, 직접옵션밸류...n, 카운트)

      showModal2: true,                       //모바일달력창

      currentDate: null,                      //가격이 있는 달을 시작월로 변경

      productId: '',
      productDetail: [],                      // 상세정보를 오브젝트형으로 변수처리

      pdtTransInfo1: {},                      //상품교통정보

      productImage: [],
      productDetailImage: [],

      selectedDate: null,
      selectedPrice: null,      
      
      reqReserveCode: "",                     //예약번호

      totalPrice: 0,                          //총구매가격

      // 리뷰영역
      reviewList: [],                         //리뷰리스트
      rShowFlag: "N",                         //리뷰작성영역표시
      noPopFlag: "N",                         //페이지이탈 경고팝업표시(Y:없음, N:경고)

      reqDptDate: null,                       //출발예정일  = selectedDate
      reqRtnDate: null,                       //리턴예정일

      memFlag: "N",                           //멤버십상품 플래그
      optCode: "noCode",                      //선택옵션 선택기본값
      sp: [],                                 //선택된 옵션정보
    };
  },
  created() {
    // path에서 사용된 productId
    this.user = this.$store.state.user;
    this.productId = this.$route.query.productId;
    this.salesRoute = this.$route.query.salesRoute;

    this.conEmail = this.user.email;

    if (this.$store.state.user.handlerId != undefined) 
    {
      this.userInfo = this.$store.state.user.handlerId;
    }
    else if (this.$store.state.user.email != undefined) 
    {
      this.userInfo = this.$store.state.user.email;
    }
    else 
    {
      this.userInfo = "";
    }
    console.log("userInfo:", this.user);

    //카카오알림용 인적정보
    if(this.user.joinFlag === "K" || this.user.joinFlag === "E" || this.userInfo.joinFlag == 'H')
    {
      this.k_name = (!this.user.nickname) ? "" : this.user.nickname;

      let kakaoPhone = ""
      if(this.user.phone != undefined &&this.user.phone.charAt(0) === '+')
      {
        //console.log("kakao:",this.user.phone.replace("+82 ", "0"))
        kakaoPhone = this.user.phone.replace("+82 ", "0")
      }
      this.k_tel = (!this.user.phone) ? "" : kakaoPhone.replace(/-/g,""); //-제거
    }
    else
    {
      this.k_name = this.user.name;
      this.k_tel = (!this.user.mobile) ? "" : this.user.mobile.replace(/-/g,""); //-제거
    }

    // NEW 상품가격-옵션정책 반영
    this.getProductDetail_new();
    //this.getFirstAvailableDate()  //가격이 있는 날짜를 달력시작월로

    //this.getProductDetail();
    // this.getPdtOptInfo()          //상품선택옵션정보
    // this.getAddPdtInfo()          //추가상품정보

  },
  mounted() {
    window.scrollTo(0, 0);

    // if(document.referrer == "")
    // {
    //   this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
    //   location.replace("/");
    // }

    //페이지 새로고침 리스너
    window.addEventListener('beforeunload', this.showPopupOnRefresh)

    ////document.getElementById("notice").style.display = "none";

    //달력 열기
    document.querySelector(".js-click-modal").addEventListener("click", () => {
      document.querySelector(".modal2").classList.toggle("open");
    });
    //달력 닫기
    document.querySelector(".js-close-modal").addEventListener("click", () => {
      document.querySelector(".modal2").classList.remove("open");
    });

    if(this.user.email != undefined)
    {
      document.getElementById("recent-item").style.display = "none";
      document.getElementById("recent-item-m").style.display = "none";
      document.getElementById("btn-recentM").style.display = "none";
    }

    //페이지뷰 카운팅
    this.countPageView(this.salesRoute, this.productId)
  },

  beforeUnmount()
  {
    window.removeEventListener('beforeunload', this.showPopupOnRefresh)
  },

  beforeRouteLeave(to, from, next) {
    //뒤로가기 시 호출
    if (this.inquiryFlag === 'Y' && this.noPopFlag != 'Y')
    {
      this.showPopupOnBack().then(shouldProceed => {
        if (shouldProceed) {
          next()
        } else {
          next(false)
        }
      })
    } else {
      next()
    }
  },
  computed: {
    user() {
      // 리턴정보가 바뀔 때마다 user()안에 넣어준다
      // 로그인전: bId정보없음, 로그인후: bId정보있음
      return this.$store.state.user;
    },

    //new calendar
    weeks()
    {
      const weeks = [];
      let weekDays = [];

      let day = this.currentDate ? this.currentDate.clone().startOf('month').startOf('week') : moment().startOf('month').startOf('week');

      const startOfMonth = this.currentDate ? this.currentDate.clone().startOf('month') : moment().startOf('month');
      const endOfMonth = this.currentDate ? this.currentDate.clone().endOf('month') : moment().endOf('month');
      const endDate = this.currentDate ? this.currentDate.clone().endOf('month').endOf('week') : moment().endOf('month').endOf('week');

      while (day.isSameOrBefore(endDate)) {
        if (day.isSameOrAfter(startOfMonth) && day.isSameOrBefore(endOfMonth)) {
          weekDays.push({
            date: day.clone(),
            price: this.getPrice(day.format('YYYY-MM-DD'))
          });
        } else {
          weekDays.push({
            date: null,
            price: null,
          });
        }

        if (weekDays.length === 7) {
          weeks.push(weekDays);
          weekDays = [];
        }

        day.add(1, 'day');
      }
      return weeks;
    },

    // 선택상품금액의 합산액
    sumPdtPrice() {
      // rsvData_temp가 있을 때만 계산
      if (!this.rsvData_temp || !this.rsvData_temp.length || this.rsvData_temp == undefined || this.rsvData_temp.length < 1) return 0;
      else 
      {
        return this.rsvData_temp.reduce((sum, item) => sum + (item.pdtPrice * (item.count ?? 0)),0)
      }
    }
  },

  watch: {
    sumPdtPrice: {
      immediate: true,      // 초기값 설정        // 컾포넌트 생성 시, 한 번 실행        
      handler(newVal) {
        this.totalPrice = newVal;               // 선택상품금액의 합산액을 showPrice에 저장
      }
    },
    // //예약정보 전개 + 예약변수 초기화 분개처리
    // inquiryFlag: function(newVal) {
    //   if(newVal === "N")
    //   {
    //     this.ageNumber = ['0','0','0','0']
    //     this.showPrice = 0
    //   }
    // },

    // defaultValFlag: function(newVal, oldVal) {
    //   if((newVal==='Y' || newVal==='N') && oldVal === 'Y')
    //   {
    //     this.ageNumber = ['0','0','0','0']
    //     this.showPrice = 0
    //   }
    // },
  },

  methods:
  {
    //페이지뷰 카운팅
    async countPageView(sRoute, pCode){
      let vParam = "V"
      let countPageView = await this.$api("/api/proc_pdtCountPageView", {param:[ sRoute, pCode, vParam ]})
      if(countPageView.affectedRows > 0)
      {
        console.log("Thank you for your visit!")
      }
    },

    // mixins에 있는 공통함수 호출샘플
    /** 자릿수 표시 */
    getCurrencyFormat(value) {
      //return this.$currencyFormat(value);
      if(isNaN(value))
      {
        location.reload()
      }
      else
      {
        return this.$currencyFormat(value);
      }
    },
    /** 개행처리 */
    getStringFormat(text) {
      return this.$stringFormat(text);
    },
    getDateFormat(date)
    {
      return this.$dateFormat(date);
    },
    /** 날짜기반요일추출 */
    getDayOfWeek(dateString) {
      return this.$getDayOfWeek(dateString)
    },

    // 선택일자의 직접형, 선택형 옵션초기화
    initializeCounts() {
      // 예약임시데이타 초기화
      this.rsvData_temp = [];
      this.choicedSelOpt = "noVal"
    },

    //직접형옵션 valid체크
    validateDirectOptions(choicedSelOpt) {
      if (this.dirOptFlag === 'Y') 
      {
        for (let i = 0; i < this.dirOptInfo.length; i++) 
        {
          if (this.dirOptInfo[i].odValue === '' || this.dirOptInfo[i].odValue == undefined) 
          {
            this.$swal.fire('', `"${this.dirOptInfo[i].odName}"에 입력값이 없습니다`, 'warning');
            return false;
          }
        }
      }
      console.log("dirOptInfo:", this.dirOptInfo)

      // 중복여부 체크(선택옵션 중복선택불가)
      let isDuplicate = this.rsvData_temp.some(item => item.selOptName === choicedSelOpt);
      if (isDuplicate) 
      {
        this.$swal.fire('', `"${choicedSelOpt}" 옵션은 이미 선택되어 있습니다.`, 'warning');
        return false;
      }

      //// 달력형 가격생성
      if(this.dTypeFlag === "Y") 
      {
        let pdtPrice_tmp = this.selectedCalPdtPrice.filter((item) => { return (item.os3 === choicedSelOpt)})
        let pdtPrice = pdtPrice_tmp[0].pdtPrice_org
        if (pdtPrice <= 0) 
        {
          this.$swal.fire('', `"${choicedSelOpt}" 옵션은 선택할 수 없습니다(상품가격 비정상)`, 'warning');
          return false;
        }
        // 중복 아니면 배열에 저장
        this.rsvData_temp.push({
          selOptName: choicedSelOpt,
          departureDate: this.selectedDate,
          directOptions: this.dirOptInfo.map(opt => opt.odValue),
          count: 0,
          pdtPrice: pdtPrice
        });
      }
      //// 비달력형 가격생성
      else
      {
        let pdtPrice_tmp = this.selectedCalPdtPrice.filter((item) => { return (item.os1 === choicedSelOpt)})
        let pdtPrice = pdtPrice_tmp[0].pdtPrice_org
        if (pdtPrice <= 0) 
        {
          this.$swal.fire('', `"${choicedSelOpt}" 옵션은 선택할 수 없습니다(상품가격 비정상)`, 'warning');
          return false;
        }
        // 중복 아니면 배열에 저장
        this.rsvData_temp.push({
          selOptName: choicedSelOpt,
          //departureDate: this.selectedDate,
          directOptions: this.dirOptInfo.map(opt => opt.odValue),
          count: 0,
          pdtPrice: pdtPrice
        });
      }      
      console.log("rsvData_temp:", this.rsvData_temp);
    },


    //new가격옵션정책용 (네이버 데이타 호환)
    async getProductDetail_new()
    {
      let productDetail = [];
      productDetail = await this.$api("/api/productDetail_new", {param: [ this.productId ]});

      if(productDetail.length > 0) {
        this.productDetail = productDetail[0];
        this.tripProp = this.productDetail.tripProp;
      }
      console.log("productDetail:", this.productDetail)

      //this.defaultValue = 'Y'
      this.getProductImage();
      this.getProductDetailImage();     // 제품상세이미지호출
      this.getProductTransInfoExited(); //상품교통정보
      this.getReviewList()              //여행후기
      this.getProductPrice_new();       //상품가격
      this.getCanBuy()                  //구매가능여부
      
      //this.getPdtPriceForCalendar_new();
    },

    //NEW 표시용 상품가격
    async getProductPrice_new()
    {
      // 오늘기준 향후 상품최소가격
      let detailPrice = await this.$api("/api/pdtDetailminPrice_new", {param: [ this.productId, this.productId ]});
      console.log("detailPrice:", detailPrice)

      if(detailPrice.length > 0)
      {
        this.detailPrice = detailPrice;
        this.pdt_basicPrice = detailPrice[0].basic_PdtPrice         // 비달력형의 경우 표시가격이 된다
        this.pdt_minPrice = detailPrice[0].basic_PdtPrice + detailPrice[0].minOptPrice
        this.osCode = detailPrice[0].osCode;
        this.prcCode = detailPrice[0].prcCode;
        this.dTypeFlag = detailPrice[0].dTypeFlag;            //날짜형 가격체계 여부

        if( this.dTypeFlag == 'N') 
        {
          //비달력형
          this.getPdtPriceForCalendar_new_noDateType(this.pdt_basicPrice, this.osCode);          
        }
        else 
        {
          // 상품달력표시용 메소드
          await this.getPdtPriceForCalendar_new(this.pdt_basicPrice, this.osCode);

          this.getFirstAvailableDate();       //가격이 있는 달이 시작월
        }
      }
    },

    async getCanBuy() {
      let canBuy = await this.$api("/api/canBuyCheck", {param: [this.productId]});
      console.log("canBuy:", canBuy)
    },


    // New 달력용 가격리스트 호출(네이버데이타 호환) => 날짜형이 아닌 정보처리
    // 달력으로 전환할 날짜데이타가 없기 때문에, 생성되는 달력에 일자별로 지정된 금액이 매칭되도록 한다
    async getPdtPriceForCalendar_new_noDateType(bsPrice, osCode)
    {
      let calPdtPrice = [];
      calPdtPrice = await this.$api("/api/calPdtPriceNew_new_nonDType", {param: [ bsPrice, osCode ]});

      // // 달력에 표시할 데일리 최저가
      // let calPdtPrice_min = [];
      // calPdtPrice_min = await this.$api("/api/calPdtPriceNew_new_min", {param: [ bsPrice, osCode ]});

      this.inquiryFlag = 'Y'                   //예약영역 표시플래그

      //달력없이 가격표시
      this.calPdtPrice = calPdtPrice;         // 일자별 상품가격
      this.priceData = calPdtPrice;             // 달력표시용 일자별 최저상품가격
      console.log("비달력형:>>>", this.calPdtPrice, this.priceData)

      
      //선택일의 권종별 가격
      let selectedCalPdtPrice = await this.$api("/api/selectedOptInfoForNoneDateType", {param:
        [ this.pdt_basicPrice, this.osCode]
      });
      if(selectedCalPdtPrice.length > 0)
      {
        this.selectedCalPdtPrice = selectedCalPdtPrice
        this.selOptFlag = "Y";                       //선택형 옵션존재여부
      }
      console.log("selectedCalPdtPrice:", this.selectedCalPdtPrice, this.selOptFlag)

      // //선택일 가격정보에서 선택형 옵션체크
      // let selOptFlag = selectedCalPdtPrice.some(item => item.os3 !== null && item.os3 !== undefined && item.os3 !== '' && item.pdtPrice_org*1 > 0 && item.sellStatus === 'Y' && item.osQty*1 > 0);
      // selOptFlag = selOptFlag ? 'Y' : 'N';
      // this.selOptFlag = selOptFlag;          //선택형 옵션존재여부
      
      //선택일 가격정보에서 직접형 옵션정보
      let dirOptInfo = await this.$api("/api/get_directOption_info", {param:[ this.productId ]});
      if(dirOptInfo.length > 0) 
      {
        this.dirOptFlag = "Y";                //직접형 옵션존재
        this.dirOptInfo = dirOptInfo;
      }
      console.log("dirOptInfo:", this.dirOptInfo)
    },

    async getPdtPriceForCalendar_new(bsPrice, osCode) ////=> 날짜형 데이타
    {
      let calPdtPrice = [];
      calPdtPrice = await this.$api("/api/calPdtPriceNew_new", {param: [ bsPrice, osCode ]});

      // 달력에 표시할 데일리 최저가
      let calPdtPrice_min = [];
      calPdtPrice_min = await this.$api("/api/calPdtPriceNew_new_min", {param: [ bsPrice, osCode ]});

      //달력에는 최소가격만 표시
      this.calPdtPrice = calPdtPrice

      // 달력표시용 가격데이타
      let priceData = {};

      priceData = calPdtPrice_min.reduce((obj, item) =>
      {
        if(item.sellStatus != 'Y' || item.osQty == 0)
        {
          obj[item.saleDate] = null;
        }
        else
        {
          obj[item.saleDate] = item.pdtPrice_org_min
        }
        return obj;
      }, {});      
      console.log("priceData:>>>", priceData)

      //this.calPdtPrice = calPdtPrice;         // 일자별 상품가격
      this.priceData = priceData;             // 달력표시용 일자별 최저상품가격
    },    

    // 달력에서 날짜선택
    selectDate_new(date)
    {
      this.initializeCounts()

      this.inquiryFlag = 'N'          //예약영역 표시플래그
      //this.defaultValFlag = 'Y'       //인원&가격정보 초기화

      let selectedDate = date;
      this.selectedDate = moment(selectedDate).format('YYYY-MM-DD')
      this.selectedPrice = this.getPrice(date.format('YYYY-MM-DD'));

      console.log("selectedDate:", this.selectedDate, "selectedPrice:", this.selectedPrice)

      // //기존권종가격 => 기본가격 +- 옵션가격
      // this.showPrice_G = 0

      // this.tot_aduCount = 0
      // this.tot_chiCount = 0
      // this.tot_infCount = 0

      if (this.selectedPrice > 0)
      {
        // 선택된 날짜를 `selDate_new` 함수에 전달
        this.selDate_new_new(this.selectedDate);
      }
    },

    //달력예약일 선택 시 처리루틴-NEW 가격옵션정책 반영(네이버 데이타 호환)
    async selDate_new_new(selDate)
    {
      this.inquiryFlag = 'Y'
      this.reqRtnDate = "";       //리턴예정일 초기화

      if(this.productDetail.tripProp === "D")                   // tripProp D: 리턴지정, F: 리턴자유
      {
        //let selecDate_tmp = new Date(this.selectedDate);
        let selecDate_tmp = new Date(selDate);
        let reqRtnDate_tmp = "";

        if(this.productDetail.stayCnt == "0")                   //당일리턴
        {
          reqRtnDate_tmp = new Date(selecDate_tmp.setDate(selecDate_tmp.getDate() + (this.productDetail.stayCnt)));
        }
        else if(this.productDetail.stayCnt > 0)                 //무박1일 포함(=당일리턴)
        {
          reqRtnDate_tmp = new Date(selecDate_tmp.setDate(selecDate_tmp.getDate() + (this.productDetail.stayCnt - 1)));
        }
        else
        {
          this.$swal.fire('', '날짜선택에 오류가 발생했습니다.<br>담당자에 문의하여 주십시오.', 'error');
          return false;
        }
        this.reqRtnDate = this.getDateFormat(reqRtnDate_tmp);
      }

      //선택일의 권종별 가격
      let selectedCalPdtPrice = await this.$api("/api/selectedDatePrice", {param:
        [ this.pdt_basicPrice, this.osCode, selDate ]
      });
      if(selectedCalPdtPrice.length > 0)
      {
        this.selectedCalPdtPrice = selectedCalPdtPrice
      }
      console.log("selectedCalPdtPrice:", this.selectedCalPdtPrice)

      //선택일 가격정보에서 선택형 옵션체크
      let selOptFlag = selectedCalPdtPrice.some(item => item.os3 !== null && item.os3 !== undefined && item.os3 !== '' && item.pdtPrice_org*1 > 0 && item.sellStatus === 'Y' && item.osQty*1 > 0);
      selOptFlag = selOptFlag ? 'Y' : 'N';
      this.selOptFlag = selOptFlag;          //선택형 옵션존재여부

      //선택일 가격정보에서 직접형 옵션정보
      let dirOptInfo = await this.$api("/api/get_directOption_info", {param:[ this.productId ]});
      if(dirOptInfo.length > 0) 
      {
        this.dirOptFlag = "Y";                //직접형 옵션존재
        this.dirOptInfo = dirOptInfo;
      }
    },

    numCount(param, selOptName){
      // this.initializeCounts()

      let item = this.rsvData_temp.find(item => item.selOptName === selOptName);
      if (!item) return;                        // 해당 옵션 없으면 무시

      if (param === 'P') 
      {
        item.count = (item.count || 0) + 1;
      } 
      else if (param === 'M') 
      {
        if ((item.count || 0) < 1)              // 1 미만으로는 감소 금지
        {  
          item.count = 0
        }
        else
        {
          item.count = (item.count || 0) - 1;
        }
      }
    },

    // 선택옵션제거
    deletePrice(sOptName) {
      // 선택된 옵션에서 해당 옵션 제거
      this.rsvData_temp = this.rsvData_temp.filter(item => item.selOptName !== sOptName);
      console.log("rsvData_temp:", this.rsvData_temp);
    }, 

    //예약하기 버튼으로 스크롤이동
    scrollToPosition(param){
      //console.log(param)
      const element = document.getElementById(param);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },

    toggle(optCode){
      if(this.selectedOptions[optCode])
      {
        this.selectedOptions[optCode] =false
      }
      else
      {
        this.selectedOptions[optCode] =true
      }
      this.$nextTick(() => {
        this.scrollToSection();
      });
    },

    // 모바일용 가격표시달력
    closeModal2()
    {
      this.showModal2 = false
    },

    toggleModal()
    {
      this.showModal2 = true
      //console.log("showModal2:", this.showModal2)
      //this.showModal2 = !this.showModal2
    },

    showPopupOnRefresh(event)
    {
      if (this.noPopFlag == 'N') // && this.inquiryFlag === 'Y'
      {
        const message = '페이지 새로고침을 하시겠습니까?작성 중 내용이 지워지게 됩니다.'
        event.returnValue = message // 반환값을 설정합니다.
      }
    },
    async showPopupOnBack()
    {
      const message = '이 페이지에서 나가시겠습니까?<br>작성 중 내용이 지워지게 됩니다.'
      const result = await this.$swal.fire({
        title: '',
        html: message,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '네',
        cancelButtonText: '아니요'
      })

      if (result.isConfirmed)
      {
        this.inquiryFlag = 'N'
        return true
      }
      else
      {
        return false
      }
    },

    checkAllConfirm()
    {
      if(this.allConfirmFlag === "Y")
      {
        this.confirm_Terms = "Y" //약관동의
        this.confirm_spTerms = "Y"
        this.confirm_Info = "Y"
        this.confirm_Privacy = "Y"
        this.confirm_3rd = "Y"
      }
      else if(this.allConfirmFlag === "N")
      {
        this.confirm_Terms = "N" //약관동의
        this.confirm_spTerms = "N"
        this.confirm_Info = "N"
        this.confirm_Privacy = "N"
        this.confirm_3rd = "N"
      }
    },

    //리뷰작성자는 리뷰를 수정할 수 있다
    changeReview(rvCode, nSeq, iSeq)
    {
      //alert("rvCode:"+rvCode+"nSeq:"+nSeq)
      this.$router.push({path: '/reviewModify', query: {rvCode: rvCode, nSeq: nSeq, iSeq: iSeq}});
    },
    /**달력표시금액 간략컨버팅*/
    formatManCurrency(amount) {
      // 만 단위로 처리하기 위해 10,000으로 나누기
      const amountInMan = amount / 10000;

      // 만 원 미만일 경우 단순히 숫자를 소수점 첫째 자리까지 표시
      if (amountInMan < 1) {
        return amountInMan.toFixed(1);
      } else if (amount >= 1000000) {
        // 100만원 초과+소숫점이 있으면 절상처리
        return Math.ceil(amountInMan).toLocaleString();
        //return Math.floor(amountInMan).toLocaleString();
      } else {
        // 만 원 이상일 경우 소수점 이하 1자리까지 표시
        const decimalPart = amountInMan - Math.floor(amountInMan);
        const roundedDecimalPart = Math.round(decimalPart * 10) / 10;

        if (roundedDecimalPart === 0) {
          return Math.floor(amountInMan).toLocaleString();
        } else {
          return (Math.floor(amountInMan) + roundedDecimalPart).toLocaleString();
        }
      }
    },

    //가격이 0이 아닌 날이 있는 월정보
    async getFirstAvailableDate()
    {
      if(this.dTypeFlag != "Y") 
      {
        return;
      }

      //await this.getPdtPriceForCalendar_new();
      const firstAvailableDate = Object.keys(this.priceData).find(date => this.priceData[date] !== null);
      if (firstAvailableDate) 
      {
        this.currentDate = moment(firstAvailableDate).startOf('month');
      } 
      else 
      {
        this.goToCurrentMonth();
      }
    },
    //상품리뷰리스트
    async getReviewList()
    {
      let reviewList = await this.$api("/api/reviewList", {param: [this.productId]});
      if(reviewList.length > 0)
      {
        this.reviewList = reviewList
      }
      //console.log("reviewList:",this.reviewList)
    },
    //new calendar
    previousMonth()
    {
      this.inquiryFlag = "N"
      //compute 원할한 처리를 위해 clone()이용
      this.currentDate = this.currentDate.clone().subtract(1, 'month');
      this.selectedDate = null;
    },
    nextMonth()
    {
      this.inquiryFlag = "N"
      this.currentDate = this.currentDate.clone().add(1, 'month');
      this.selectedDate = null;
    },
    goToCurrentMonth()
    {
      this.inquiryFlag = "N"
      const today = moment();
      this.currentDate = moment([today.year(), today.month(), today.date()]);
      this.selectedDate = null;
    },

    getPrice(date) {
      if (!this.priceData)
      {
        // priceData 객체가 로딩되지 않았다면 로딩하기
        // this.getPdtPriceForCalendar();
        this.getPdtPriceForCalendar_new()
      }
      if (date in this.priceData)
      {
        // priceData 객체에서 날짜에 해당하는 가격 추출하여 숫자로 변환하여 반환
        const price = this.priceData[date];
        return Number(price);
      }
      else
      {
        // const price = null
        // console.log("price:",price)
        return null
      }
    },

    isToday(date)
    {
      return moment().isSame(date, 'day');
    },

    //모먼트를 이용한 일자검증
    isSelected(date)
    {
      if (!this.selectedDate)
      {
        return false;
      }
      else if (moment(this.selectedDate).isSame(date, 'day'))
      {
        return true;
      }
      else
      {
        return false;
      }
    },

    goTo(id) {
      var element = document.getElementById(id);
      if (element)
      {
        element.scrollIntoView({ behavior: 'smooth' });
      }
      else
      {
        console.error('Element with the specified ID not found');
      }
    },

    showFlag() {
      this.rShowFlag = (this.rShowFlag == 'Y') ? 'N' : 'Y'
      //alert(this.rShowFlag)
    },    

    //모바일디바이스 대응
    scrollToId(id)
    {
      const element = document.getElementById(id);

      if (element) {
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;

        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    },

    //상품교통정보
    async getProductTransInfoExited() {
      let pdtTransInfo1 = await this.$api("/api/pdtTransInfo_existed", {param: [this.productId]});
      if(pdtTransInfo1.length > 0) {
        this.pdtTransInfo1 = pdtTransInfo1[0];
      }
      console.log("pdtTransInfo1:",this.pdtTransInfo1);
    },

    async getProductImage() {
      // 상세페이지용 카로우셀 이미지
      let productImage = await this.$api("/api/productImage", {param: [this.productId]});
      this.productImage = (productImage.length > 0) ? productImage : "";
      //console.log("productImage:", this.productImage)
    },
    async getProductDetailImage() {
      // 상세설명이미지 호출
      // let noImage = this.noImage;
      let productDetailImage = await this.$api("/api/productDetailImage_new", {param: [this.productId]});
      this.productDetailImage = (productDetailImage.length > 0) ? productDetailImage : "";
      //console.log("productDetailImage:", this.productDetailImage);
    },

    //단순상품문의
    inquiryProduct() {
      //alert(this.productId);
      this.$router.push({path: '/inquiryProduct', query: {productId: this.productId, salesRoute:this.productDetail.salesRoute}});
    },

    //예약코드생성
    async genCode(param) {
      let chkFlag = "N";
      let rtnCode = "";

      for (let attempts = 0; attempts < 1000 && chkFlag === "N"; attempts++)
      {
        let today = new Date();
        let yy = today.getFullYear().toString().slice(-2);
        let mm = today.getMonth() + 1;
        let dd = today.getDate();
        let ymd = `${yy}${mm}${dd}`;
        let dCd = param + ymd;

        rtnCode = await genCode(this.$api, dCd);
        //console.log("rtnCode:",rtnCode)

        let chk_genCode = await this.$api("/api/checkDub_resCode", { param: [rtnCode] });

        if (chk_genCode.length > 0) {
          chkFlag = "N";
        } else {
          chkFlag = "Y";
        }
      }
      //console.log("chkFlag:", chkFlag)
      if (chkFlag === "N")
      {
        this.$swal.fire("","예약번호 생성횟수 한계에 도달하였습니다.<br>담당자에게 문의(1660-4602)하여 주세요.","warning")
        return false;
      }
      else
      {
        return rtnCode
      }
    },



    // 예약하기 체크
    async orderCheck_new(flag) {
      this.showModal2 = false
      console.log(flag+'21K23!98h40D')
      //로그인체크
      if(this.userInfo == undefined || this.userInfo == "" || !this.userInfo)
      {
        //this.$swal.fire("","로그인이 필요합니다.","info");
        this.$swal.fire({
          html: "엔타비글로벌여행사를 이용해주셔서 감사합니다<br>회원이신 경우, 로그인 후 진행하여 주십시오.<br>비회원이신 경우, 회원가입 또는 비회원으로 예약진행이 가능합니다.",
          showCancelButton: false,
          showDenyButton: true,
          confirmButtonText: "로그인 페이지로 이동",
          denyButtonText: "비회원으로 예약진행",
          imageUrl: '/IMGs/welcome.png',
          imageWidth: 400,
          imageHeight: 200,
        })
        .then((result) => {
            if(result.isConfirmed)
            {
              this.$router.push({path: '/b2CLogin', query:{st: "Y"}});
            }
            else if(result.isDenied)
            {
              this.memberFlag = "N"
              //console.log("choiceMemberFlag:", this.memberFlag)
              this.order_new(flag)
            }
          })
        }
        else
        {
          this.order_new(flag)
        }
      },

    // 예약하기
    async order_new(flag) {
      //sumPdtPrice

      this.noPopFlag = "Y"                              //새로고침방지

     //예약번호생성
      let catCode = "RQ-" + this.salesRoute;
      let reqReserveCode = await this.genCode(catCode)
      this.reqReserveCode = reqReserveCode
      console.log("flag1:", flag+'21K23!98h40D')

      this.reqRtnDate = (this.reqRtnDate == "") ? null : this.reqRtnDate;

      let totalCount = this.rsvData_temp.reduce((sum, item) => sum + (item.count ?? 0), 0);

      //소숫점절사
      //let reqPdtPriceFin = (this.showPrice).toFixed(0)*1
      let reqPdtPriceFin = (this.totalPrice).toFixed(0)*1

      if(reqReserveCode === undefined || this.totalPrice === undefined || this.totalPrice < 0 || this.productDetail.pdtCode === undefined) {
        var swal = require('sweetalert2');
        swal.fire({
          html: '예약진행 중 오류가 있습니다.<br>확인 후 재신청하여 주십시오',
          icon: 'warning'
        });
        return false;
      }
      else if(totalCount < 1) {
        this.$swal.fire("","구입상품수를 확인해주세요","question");
        return false;
      }
      else
      {
        // let disCnt = 0
        // let disPrice = 0
        let rCopyFlag = "N"
        let reqStatus = "IQ"
        let completeFlag = "N"
        let newResFlag = "Y"              // new 예약
        //this.userInfo = handlerId OR user.email

        //예약마스터 임시생성 (네이버데이타 호환화)
        let res_insReserveM = await this.$api("/api/proc_insReserve_m_new_new", {param: [
          this.reqReserveCode,this.productId,reqStatus,this.selectedDate,
          this.tot_vatPrice,this.reqRtnDate,this.tripProp,this.productDetail.stayCnt,reqPdtPriceFin,reqPdtPriceFin,rCopyFlag,
          this.productDetail.ctCd,completeFlag,
          this.productDetail.nrFlag,this.productDetail.vrFlag, this.memberFlag,
          newResFlag,totalCount,reqPdtPriceFin,this.dirOptFlag,this.selOptFlag
        ]});

        if(res_insReserveM.affectedRows < 0 || res_insReserveM.affectedRows === undefined)
        {
          this.$swal.fire('','<b class="text-danger">죄송합니다</b><br>처리 중 문제가 발생했습니다.('+ res_insReserveM.error.sqlMessage +')', 'warning')
          return false;
        }
        else
        {
          // 선택옵션 존재 시 처리
          if(this.selOptFlag === "Y")
          {
            let successCount = 0;
            let errors = [];

            for(let i=0; i<this.rsvData_temp.length; i++)
            {
              let optCode = this.osCode

              let optUseFlag = "Y"
              let optCompFlag = "N"
              //console.log("optCode:::://///:", optCode)
              try {
                await this.$api("/api/proc_insReserve_opt_new", {param: [
                  this.reqReserveCode, this.productId, optCode, this.rsvData_temp[i].selOptName, this.rsvData_temp[i].count, optUseFlag, optCompFlag, this.rsvData_temp[i].pdtPrice

                ]});
                successCount++;
              } 
              catch (error) 
              {
                console.log(error)
                errors.push(error);
              }
            }

            if(successCount != this.rsvData_temp.length)
            {
              this.$swal.fire("", `선택옵션의 예약등록에 실패했습니다. 재진행을 부탁드립니다.<br>반복오류 발생 시, 문의처(1566-4602)`, "error");
              return false
            }
          }

          // 직접형옴션 선택 시, 저장처리
          if(this.dirOptFlag === "Y")
          {
            let successCount = 0;
            let errors = [];

            for(let i=0; i<this.dirOptInfo.length; i++)
            {
              let odCode = this.dirOptInfo[i].odCode
              let odName = this.dirOptInfo[i].odName
              let odValue = this.dirOptInfo[i].odValue
              // let dirPrice1 = this.dirOptInfo[i].odPrice1
              let dirUseFlag = "Y"                            //addUseFlag<=직접형 옵션 사용여부
              let dirCompFlag = "N"                           //addCompFlag<=직접형 옵션 완료여부    

              try {
                await this.$api("/api/proc_insReserve_dirOpt_new", {param:[
                    this.reqReserveCode, this.productId, dirUseFlag, dirCompFlag, odCode, odName, odValue
                ]});

                successCount++;
              } catch (error) {
                console.log(error)
                errors.push(error);
              }
            }

            if(successCount != this.dirOptInfo.length)
            {
              this.$swal.fire("", `직접형 옵션의 예약등록에 실패했습니다. 재진행을 부탁드립니다.<br>반복오류 발생 시, 문의처(1566-4602)`, "error");
              return false
            }
          }

          this.$router.push({path: "/reservation", query: {
            resCode: this.reqReserveCode, prodId: this.productId
          }})
        }
      }
    },
  }
}
</script>

<style scoped>
@import "../assets/css/style.css";

#product{
  margin-top:4rem;
}

#recent-item{
  display: none;
}


/* -------------------------------------------------
  # 왼쪽
--------------------------------------------------- */
#product .pr-left{
  padding-right:1rem
}
@media (max-width:991px){
  #product .pr-left{
    padding-right:0
  }
}


/* -----------------
  타이틀
----------------- */
#product .pr-left .section-tittle {
  margin: 2rem 0 1rem;
  text-align: left !important
}
#product .pr-left .section-tittle h2 {
  font-size: 1.8rem;
  display: block;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 5px;
  padding-left:10px;
  color: #111;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  #product .pr-left .section-tittle h2 {
    font-size: 1.7rem
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  #product .pr-left .section-tittle h2 {
    font-size: 1.6rem
  }
}
@media (max-width: 575px) {
  #product .pr-left .section-tittle h2 {
    font-size: 1.3rem
  }
}


/* -----------------
  사진
----------------- */
#product .pr-left .carousel-inner img {
  height: 500px;
  object-fit: cover
}

@media (max-width:991px){
  #product .pr-left .carousel-inner img{
    height: 350px;
  }
}


/* -----------------
  상품번호
----------------- */
#product .pr-left .subheading{
  font-size: .8rem;
  color: #999;
  margin-bottom: 5px;
}


/* -----------------
  교통편,체크포인트
----------------- */
#product .pr-left .vech{
  margin-top:2.5rem;
  border-top:2px solid #000
}
#product .pr-left .vech .stand{
  background-color: #F8F8F8;
  color:#000;
  font-size:1.1rem;
  font-weight: 600;
  text-align: center;
  letter-spacing: 5px;
  width:170px;
  vertical-align:middle
}
#product .pr-left .vech .sub{
  padding:1rem 0 1rem 1.5rem
}

@media (max-width:991px){
  #product .pr-left .vech .stand{
    font-size:.95rem;
    letter-spacing: 0;
    width:85px;
  }
  #product .pr-left .vech .sub{
    padding:1rem 0 1rem .5rem;
    font-size:.9rem
  }
}



/* -----------------
  포함,불포함
----------------- */
#product .pr-left .in-non{
  margin-top:5rem;
  border-top:2px solid #000
}
#product .pr-left .in-non thead th{
  background-color: #F8F8F8;
  height:4rem;
  text-align: center;
  vertical-align:middle;
  font-size:1.1rem;
  font-weight: 600
}
#product .pr-left .in-non thead th:first-child,
#product .pr-left .in-non tbody td:first-child{
  border-right: 1px solid #ddd;
}
#product .pr-left .in-non tbody td{
  text-align: center;
  vertical-align:middle;
  padding:20px 0
}

@media (max-width:991px){
  #product .pr-left .in-non thead th{
    font-size:1rem;
    height:3.5rem;
  }
  #product .pr-left .in-non tbody td{
    font-size:.9rem;
    padding:15px 0
  }
}



/* -----------------
  카테고리
----------------- */
#product .pr-left .category {
  margin: 7rem 0;
}
#product .pr-left .category .clist{
  margin: 4rem 0;
  border-bottom: 3px solid #000;
  padding-bottom:1rem
}
#product .pr-left .category .nav-tabs {
  border:none
}
#product .pr-left .category ul li{
  display: inline-block;
  margin-right: 3rem
}
#product .pr-left .category ul li:last-child{
  margin-right:0
}

#product .pr-left .category .nav-link{
  border:none;
  color: #999;
}

#product .pr-left .category .nav-item h4{
  position: relative;
  font-size: 1.3rem;
  margin: 0;
  font-weight: 600;
  transition: all 500ms ease-out;
}

#product .pr-left .category .nav-item h4::after{
  position: absolute;
  display:block;
  content: '';
  border-top:none;
  border-right:none;
  border-left:none;
  border-bottom: 5px solid #000;
  transition: all 250ms ease-out;
  bottom:-29px;
  left: 50%;
  width: 0;
}

#product .pr-left .category .nav-item:hover h4::after{
  transition: all 250ms ease-out;
  left: 0%;
  width: 100%;
}

#product .pr-left .category .nav-item:hover h4{
  color:#000
}


#product .pr-left .category .nav-tabs .nav-link.active {
  color:#000;
}


@media (max-width:1200px) {
  #product .pr-left .category ul li{
    margin-right: 1.5rem
  }
  #product .pr-left .category .nav-item h4{
    font-size:1.1rem
  }
}
@media (max-width:767px) {
  #product .pr-left .category ul li{
    margin-right: .8rem
  }
  #product .pr-left .category ul li .nav-link{
    padding:0 5px
  }
  #product .pr-left .category .nav-item h4{
    font-size:.95rem
  }
  #product .pr-left .category .nav-item h4::after{
    bottom:-21px;
  }
}
@media (max-width:453px) {
  #product .pr-left .category ul li{
    margin-right: .5rem
  }
  #product .pr-left .category .nav-item h4{
    font-size:.8rem
  }
}

/* ---- 카테고리제목 ---- */
#product .pr-left .category .tab-pane h4{
  font-weight: 600;
}

/* ---- 이용후기 ---- */
#product .pr-left .category .creview{
  position:relative
}
#product .pr-left .category .creview p {
  font-size: 0.8rem;
  margin-top: 20px
}
#product .pr-left .category .creview img{
  width:auto;
  height:220px !important;
  object-fit: cover;
}
#product .pr-left .category .creview .c-content{
  padding-top:10px
}
#product .pr-left .category .creview .reviewt{
  font-size:1.4rem;
  font-weight: bold;
}
#product .pr-left .category .creview .reviewn{
  font-size:.75rem;
  color:#aaa
}
#product .pr-left .category .creview .reviewn .name{
  border-right:1px solid #aaa;
  padding-right:15px
}
#product .pr-left .category .creview .reviewn .date{
  padding-left:15px
}
#product .pr-left .category .creview .reviewc{
  font-size:.9rem;
  padding:10px 0 30px
}
@media (min-width:992px){
  #product .pr-left .category .creview .c-content{
    padding-left:30px
  }
}




/* -------------------------------------------------
  # 오른쪽
--------------------------------------------------- */
#product .pr-right{
  display: block;
  margin-top:0rem;
  padding-bottom:0rem;
  border:1px solid #000;
  border-radius: 15px;
  background-color:rgba(255, 252, 252, 0.8);
  width: 22rem;
}

/* #product .pr-right .container{
  align-items: center;
  background-color:rgba(255, 252, 252, 0.8);
} */


/* -----------------
  달력
----------------- */
/* 글자 */
/* #product .pr-right .top{
  text-align:center;
  margin-top:0.5rem;
  font-size:1.5rem;
  color:#000;
  font-weight: 600;
} */

/* 윗부분 */
#product .pr-right .calendar{
  width:100%
}
#product .pr-right .calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  background-color:rgba(2, 13, 39, 0.8);
}
#product .pr-right .calendar-header-date {
  font-size: 1.3rem;
  font-weight: bold;
  position: relative;
  top:50%;
  transform: translateY(30%);
  color:white;
}

/* 버튼 아이콘 */
#product .pr-right .calendarbtn {
  border: 0px;
  background-color: transparent;
  position: relative;
  top:50%;
  transform: translateY(30%);
  color:white;
}

/* 안에 내용 */
#product .pr-right .calendar-row {
  display: flex;
  cursor: pointer;
}
#product .pr-right .calendar-day-header {
  width: calc(100% / 7);
  text-align: center;
  padding: 1px;
  font-weight: 700;
  font-size: 1.1rem;
}
#product .pr-right .calendar-day {
  width: calc(100% / 7);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
}
#product .pr-right .calendar-date {
  font-size: 1.0rem;
  font-weight: normal;
}

/* 오늘 날짜 */
#product .pr-right .calendar-day.today .calendar-date{
  border:2px solid #f00;
  text-align: center;
}
#product .pr-right .calendar-day.today .calendar-date{
  border:2px solid #f00;
  border-radius: 25%;
  width:30px;
  height:34px;
  text-align: center;
}

#product .pr-right .calendar-day.today::before {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 80%;
  z-index: 1;
  background-color: transparent;
}
#product .pr-right .calendar-day.today .calendar-date {
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
}

/* 가격들 */
#product .pr-right .calendar-price {
  margin-top: 0.1rem;
  font-size: 0.8rem;
}


/* -----------------
  금액
----------------- */
#product .pr-right .price{
  margin-top:.5rem;
}
#product .pr-right .price table{
  width: 80%;
  margin-left:auto;
  margin-right:auto;
}
#product .pr-right .price td{
  font-size:.9rem;
  font-weight:600;
  color:#000;
  margin:5px 0
}
#product .pr-right .price .bi-question-square{
  font-size:.9rem;
  font-weight: normal;
  color:darkblue;
}

/* 인원수조정 */
#product .pr-right .price .count{
  text-align: center;
  padding: 0 10px;
}
#product .pr-right .price .count .btn-group{
  border:1px solid #000;
  border-radius: 0;
}
#product .pr-right .price .count .number{
  border-right:1px solid #000;
  border-left:1px solid #000;
  width: 3.5rem;
  padding:8px 0
}
#product .pr-right .price .count .left,
#product .pr-right .price .count .right{
  font-size:1rem
}
#product .pr-right .price .count .btn-check:focus+.btn,
#product .pr-right .price .count .btn:focus{
  border-radius: 0;
}


/* -----------------
  총금액
----------------- */
#product .pr-right .total-P table{
  margin-left:auto;
  margin-right:auto;
}
#product .pr-right .total{
  margin-top:1rem
}
#product .pr-right .total span{
  font-size:1.0rem;
  padding-left:1px
}
#product .pr-right .total .result{
  padding-left:5px;
  font-size:1.5rem;
  font-weight: 600;
  color:#000
}


/* ----------------------------------
  예약하기 버튼
---------------------------------- */
#product .pr-right .pr-go{
  margin-top:0.5rem;
  text-align: center;
}
#product .pr-right .pr-go p{
  color:#fff;
  font-size:1.2rem;
  font-weight: 600;
  letter-spacing: 5px;
  background-color: #676666;
  padding:13px 0;
  border-radius: 10px;
  margin-bottom:0;
}
#product .pr-right .pr-go p:hover{
  color:gold;
  background-color: #000;
}

.checkPoint, .supPre, .supCxl,
.inclusion, .notInclusion,
.reviewContent {
  word-wrap:break-word;
  white-space:pre-wrap;
}

/* ----------------------------------
  멤버십 배너버튼
---------------------------------- */
#product .pr-right .mem-go{
  margin-top:0.5rem;
  text-align: center;
}
#product .pr-right .mem-go p{
  color:#fff;
  font-size:1.0rem;
  font-weight: 600;
  letter-spacing: 5px;
  background-color:royalblue;
  padding:13px 0;
  border-radius: 10px;
  margin-bottom:0
}
#product .pr-right .mem-go p:hover{
  color: white;
  background-color: goldenrod;
}

/* .checkPoint, .supPre, .supCxl,
.inclusion, .notInclusion,
.reviewContent {
  word-wrap:break-word;
  white-space:pre-wrap;
} */


/* 오른쪽 화면 모바일에서 사라지게 */
@media (max-width:991px){
  #product .pr-right{
    display:none
  }
}


/* -------------------------------------------------
  # 모바일 예약하기
--------------------------------------------------- */
#product .mobile-cal{
  display: block;
}

#product .mobile-cal .openm{
  background: rgba(80, 80, 80);
  color: #fff;
  text-align: center;
  padding:15px 0;
  transition: all .4s ease;
  cursor: pointer;
  width:100%;
  position: fixed;
  left:0;
  bottom: 0;
}

#product .mobile-cal .modal2 {
  background: #fff;
  width: 100%;
  height: 100%;
  overflow-y:scroll;
  margin: 0;
  padding: 0;
  transition: all 600ms cubic-bezier(0.86, 0, 0.07, 1);
  top: 100%;
  position: fixed;
  left: 0;
  text-align: left;
}
#product .mobile-cal .modal2 .body {
  padding: 40px 10px 90px 10px;
  position: relative;
}

#product .mobile-cal .modal2 .closem{
  position:absolute;
  top:5px;
  right:3%;
}


/* -----------------
  모바일 달력
----------------- */
#product .modal2 .calendar{
  width:100%;
  margin:0
}
#product .modal2 .calendar-header-date{
  font-size:1.5rem
}
#product .modal2 .calendar-row{
  margin:10px 0
}
#product .modal2 .calendar-day{
  height:auto
}
#product .modal2 .calendar-date{
  font-size:1rem
}
#product .modal2 .calendar-day.today .calendar-date{
  border:2px solid #f00;
  border-radius: 25%;
  width:34px;
  height:34px;
  text-align: top;
}




/* -----------------
  모바일 가격
----------------- */
#product .modal2 .price table{
  width:100%
}
/* 인원수조정 */
#product .modal2 .price .count{
  text-align: center;
  padding: 0 0px;
}
#product .modal2 .price .count .btn-group{
  border:1px solid #000;
  border-radius: 0;
}
#product .modal2 .price .count .number{
  border-right:1px solid #000;
  border-left:1px solid #000;
  width: 3.5rem;
  font-weight:600;
  padding:11px 0
}
#product .modal2 .price .count .left,
#product .modal2 .price .count .right{
  font-size:1.3rem
}
#product .modal2 .price .count .btn-check:focus+.btn,
#product .modal2 .price .count .btn:focus{
  border-radius: 0;
}

/* 총금액 */
#product .modal2 .total-P table{
  margin-left:auto;
  margin-right:auto;
}
#product .modal2 .total .result{
  padding-left:10px;
  font-size:2.3rem;
  font-weight: 600;
  color:#000
}

/* 예약하기 버튼 */
#product .modal2 .pr-go{
  margin-top:0.5rem;
  text-align: center;
}
#product .modal2 .pr-go p{
  color:#fff;
  font-size:1.0rem;
  font-weight: 600;
  letter-spacing: 2px;
  background-color: #676666;
  padding:15px 0;
  border-radius: 12px;
  margin-bottom:.5rem
}
#product .modal2 .pr-go p:hover{
  color:gold;
  background-color: #000;
}



/* 열었을 때 */
#product .mobile-cal .open{
  top: 10%;
  z-index: 1000;
  box-shadow: 0 -5px 20px rgba(0,0,0,0.2);
}

.high-z-index {
  z-index: 9000 !important;
}

/* pc 화면 안 보임 */
@media (min-width:992px){
  #product .mobile-cal{
    display: none;
  }
}



/* -------------------------------------------------
  # 캘린더에 필요한 것!
--------------------------------------------------- */
.calendar {
  display: inline-block;
  border: 0px solid #ccc;
  font-family: sans-serif;
  width: 90%
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 0 10px ;
  /*background-color: #eee;*/
  border-bottom: 2px solid #ccc;
}

.calendar-header-date {
  font-size: 2rem;
  font-weight: bold;
}

.calendar-body {
  display: flex;
  flex-direction: column;
}

.calendar-row {
  display: flex;
  margin:3px 0;
  cursor: pointer;
}

.calendar-header-row {
  font-weight: bold;
}

.calendar-day-header {
  width: calc(100% / 7);
  text-align: center;
  padding: 5px;
}

.calendar-day {
  width: calc(100% / 7);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3px;
  height:auto
  /* day border
  border-right: 0px solid #ccc;
  border-bottom: 0px solid #ccc;
  */
}

.calendar-day.today {
  background-color: transparent;
  /*position: relative;*/
}
.calendar-day.today .calendar-date{
  border:3px solid #f00;
  border-radius: 25%;
  width:40px;
  height:38px;
}

.calendar-day.today .calendar-date {
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
}

.calendar-day.today::before {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: transparent;
}

.calendar-day:last-child {
  border-right: none;
}

.calendar-day.selected {
  background-color: #ccc;
}

.calendar-date {
  font-size: 1.3rem;
  font-weight: normal;
  color:#666;
}

.calendar-price {
  margin-top: 3px;
  font-size: 0.8rem;
  font-weight: bold;
  color:darkslategray
}

.calendarbtn {
  border: 0px;
  background-color: transparent;
}

.pr-right {
  position: sticky;
  top: 0;
}


/**
  # 직접형 옵션설정
*/
.doInput::placeholder {
  font-size: 0.9rem;
  color: lightgray;
}

</style>